import { render, staticRenderFns } from "./InvoiceDetailView.vue?vue&type=template&id=3afa6627&"
import script from "./InvoiceDetailView.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailView.vue?vue&type=style&index=0&id=3afa6627&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports